// libs
import React, { memo } from 'react';

// helpers
import { getAkamaiUrl } from 'shared/helpers/utils';

const BADGE_HEIGHT = 16;

interface IBadgeProps {
  value?: ProductDetail.IBadge;
}

const DEFAULT_VALUE = {
  imageUrl_ios: '',
  imageUrl: '',
  title: '',
};

function Badge({ value = DEFAULT_VALUE }: IBadgeProps) {
  const { imageUrl, title } = value;

  if (!imageUrl) {
    return null;
  }

  return (
    <img
      src={getAkamaiUrl(imageUrl, { height: BADGE_HEIGHT * 2 })}
      alt={title}
      height={BADGE_HEIGHT}
      data-test="title-badge"
      loading="lazy"
      className="badge-img"
    />
  );
}

export default memo(Badge);
